module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content dash"
  }, [_c('div', {
    staticClass: "dash-hero"
  }, [_c('p', {
    staticClass: "dash-date"
  }, [_vm._v(_vm._s(_vm.today))]), _vm._v(" "), _c('h1', {
    staticClass: "dash-greeting"
  }, [_vm._v(_vm._s(_vm.greeting) + ", " + _vm._s(_vm.firstName))]), _vm._v(" "), _c('p', {
    staticClass: "dash-sub"
  }, [_vm._v("What would you like to work on?")]), _vm._v(" "), _c('div', {
    staticClass: "dash-search",
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.preventDefault();
        return _vm.move(1)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.preventDefault();
        return _vm.move(-1)
      }]
    }
  }, [_c('i', {
    staticClass: "fa fa-search dash-search-icon"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    ref: "search",
    staticClass: "dash-search-input",
    attrs: {
      "type": "text",
      "placeholder": "Search pages, e.g. keywords, templates, campaign",
      "aria-label": "Search pages"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "focus": function($event) {
        _vm.open = true
      },
      "blur": _vm.close,
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.go(_vm.results[_vm.active])
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        _vm.query = ''
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.open && _vm.query) ? _c('ul', {
    staticClass: "dash-results"
  }, [_vm._l((_vm.results), function(item, i) {
    return _c('li', {
      key: item.key,
      staticClass: "dash-result",
      class: {
        'dash-result--active': i === _vm.active
      },
      on: {
        "mousedown": function($event) {
          $event.preventDefault();
          return _vm.go(item)
        },
        "mouseenter": function($event) {
          _vm.active = i
        }
      }
    }, [_c('i', {
      staticClass: "fa",
      class: item.icon
    }), _vm._v(" "), _c('span', {
      staticClass: "dash-result-label"
    }, [(item.section) ? _c('span', {
      staticClass: "dash-result-section"
    }, [_vm._v(_vm._s(item.section) + " ›")]) : _vm._e(), _vm._v("\n              " + _vm._s(item.label) + "\n            ")]), _vm._v(" "), (i === _vm.active) ? _c('i', {
      staticClass: "fa fa-level-down fa-rotate-90 dash-result-enter"
    }) : _vm._e()])
  }), _vm._v(" "), (!_vm.results.length) ? _c('li', {
    staticClass: "dash-result dash-result--empty"
  }, [_vm._v("No pages match \"" + _vm._s(_vm.query) + "\"")]) : _vm._e()], 2) : _vm._e()])]), _vm._v(" "), _c('h2', {
    staticClass: "dash-heading"
  }, [_vm._v("Quick actions")]), _vm._v(" "), _c('div', {
    staticClass: "dash-actions"
  }, _vm._l((_vm.actions), function(action) {
    return _c('router-link', {
      key: action.to,
      staticClass: "dash-action",
      attrs: {
        "to": action.to
      }
    }, [_c('span', {
      staticClass: "dash-action-icon"
    }, [_c('i', {
      staticClass: "fa",
      class: action.icon
    })]), _vm._v(" "), _c('span', {
      staticClass: "dash-action-text"
    }, [_c('span', {
      staticClass: "dash-action-title"
    }, [_vm._v(_vm._s(action.title))]), _vm._v(" "), _c('span', {
      staticClass: "dash-action-desc"
    }, [_vm._v(_vm._s(action.desc))])]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-angle-right dash-action-arrow"
    })])
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-0606b51e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = TrvX
// module chunks = 1